export const FlyingNotificationSlugsEnum = {
    LAST_LOGIN: 'lastLogin',
};
